// @mui material components
import Grid from "@mui/material/Grid";
import MDBox from "../../../../../components/MDBox";
import FormField from "../../../../../components/FormField";
import React from "react";
import MDTypography from "../../../../../components/MDTypography";
// Material Dashboard 2 PRO React components

function NewProductForm({formData}) {
    const {formField, values, errors, touched} = formData;

    const {name, formula, price, cost, fee_percent, description, brand, image_name, discount_percent} = formField;
    const {
        name: nameV,
        formula: formulaV,
        price: priceV,
        cost: costV,
        fee_percent: feePercentV,
        discount_percent: discountPercentV,
        description: descriptionV,
        brand: brandV,
        image_name: imageNameV
    } = values;

    return (
        <MDBox>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={name.type}
                        label={name.label}
                        name={name.name}
                        value={nameV}
                        error={errors.name && touched.name}
                        success={nameV && nameV.length > 0 && !errors.name}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={formula.type}
                        label={formula.label}
                        name={formula.name}
                        value={formulaV}
                        error={errors.formula && touched.formula}
                        success={formulaV && formulaV.length > 0 && !errors.formula}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={brand.type}
                        label={brand.label}
                        name={brand.name}
                        value={brandV}
                        error={errors.brand && touched.brand}
                        success={brandV && brandV.length > 0 && !errors.brand}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={price.type}
                        label={price.label}
                        name={price.name}
                        value={priceV}
                        error={errors.price && touched.price}
                        success={priceV && priceV.length > 0 && !errors.price}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={cost.type}
                        label={cost.label}
                        name={cost.name}
                        value={costV}
                        error={errors.cost && touched.cost}
                        success={costV && costV.length > 0 && !errors.cost}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={fee_percent.type}
                        label={fee_percent.label}
                        name={fee_percent.name}
                        value={feePercentV}
                        error={errors.fee_percent && touched.fee_percent}
                        success={feePercentV && feePercentV.length > 0 && !errors.fee_percent}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={discount_percent.type}
                        label={discount_percent.label}
                        name={discount_percent.name}
                        value={discountPercentV}
                        error={errors.discount_percent && touched.discount_percent}
                        success={discountPercentV && discountPercentV.length > 0 && !errors.discount_percent}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={image_name.type}
                        label={image_name.label}
                        name={image_name.name}
                        value={imageNameV}
                        error={errors.image_name && touched.image_name}
                        success={imageNameV && imageNameV.length > 0 && !errors.image_name}
                        {...image_name}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={description.type}
                        label={description.label}
                        name={description.name}
                        value={descriptionV}
                        error={errors.description && touched.description}
                        success={descriptionV && descriptionV.length > 0 && !errors.description}
                        {...description}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default NewProductForm;
